import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "haptic"
  static values = { style: { type: String, default: "medium" } }

  connect() {
    super.connect()
    console.log("[haptic] connect", {
      element: this.element.tagName,
      id: this.element.id,
      classes: this.element.className,
      style: this.styleValue,
      enabled: this.enabled
    })
  }

  tap(event) {
    console.log("[haptic] tap fired", {
      eventType: event?.type,
      enabled: this.enabled,
      style: this.styleValue,
      element: this.element.tagName,
      id: this.element.id
    })
    if (this.enabled) {
      this.send("tap", { style: this.styleValue })
      console.log("[haptic] send dispatched")
    } else {
      console.log("[haptic] bridge NOT enabled — native side not connected")
    }
  }
}
